/**
 * KEV Cell Renderer
 *
 * Renders the CISA KEV (Known Exploited Vulnerabilities) indicator.
 * Displays Yes/No/- based on whether the vulnerability is in CISA's KEV catalog.
 */

import React from 'react';

import type { RiskWithVulnerability } from '@/hooks/useRisks';

interface KEVCellProps {
  risk: RiskWithVulnerability;
}

/**
 * Memoized cell renderer for CISA KEV column
 *
 * Displays whether the vulnerability is listed in CISA's Known Exploited
 * Vulnerabilities catalog. Shows "Yes" if in KEV, "No" if not, or "-" if unknown.
 *
 * Note: Currently uses the same 'exploit' field as ExploitCell.
 * This may be refactored to use a dedicated 'kev' field in the future.
 *
 * @param risk - The vulnerability/risk to check for KEV status
 * @returns Text indicator of KEV status
 */
export const KEVCell: React.FC<KEVCellProps> = React.memo(({ risk }) => {
  const displayText =
    risk.exploit === undefined ? '-' : risk.exploit ? 'Yes' : 'No';

  return <span className="text-chariot-text-primary">{displayText}</span>;
});

KEVCell.displayName = 'KEVCell';
